"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastpathChildPath = void 0;
exports.FastpathChildPath = {
    financialProfile: 'financial-profile',
    riskAttitude: 'risk-attitude',
    chooseAccounts: 'choose-accounts',
    enroll: 'enroll',
    openYourAccount: 'open-your-account',
    portfolioBuilder: 'portfolio-builder',
    projectedPortfolio: 'projected-portfolio',
    error: 'error',
    fundManagementExplorer: 'fund-management-explorer',
};
